import { PlusIcon } from 'assets/icons/PlusIcon'
import React from 'react'
import { Button, Flex } from 'styling/GlobalStyles'
import { useNavigate } from 'react-router-dom'

export const DashboardActions = () => {
  const navigate = useNavigate()
  return (
    <>
      <Button orange width='220' onClick={() => navigate('/procurement/create')}>
        <Flex gap='0.5rem'>
          {PlusIcon}
          Create purchase request
        </Flex>
      </Button>
      <Button orange width='140'>
        View Reports
      </Button>
    </>
  )
}
